// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/aerial_shot_cropped.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.request-password-reset-page {
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items: center;
  background-color: #e8f4f9;
}

  .request-password-reset-page__left-sidebar {
    padding: 30px;
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  @media screen and (width >= 720px) {

  .request-password-reset-page__left-sidebar {
      padding: 30px;
      width: 300px;
      height: 521px
  }
    }

  .request-password-reset-page__content {
    display: flex;
    width: 100vw;
    height: 100vh;
    background-color: white;
  

  }

  @media screen and (width >=720px) {

  .request-password-reset-page__content {
      width: 720px;
      height: 521px;
      border-radius: 6px;
      box-shadow: 0 20px 40px 0 rgb(0 26 6 / 20%)
  

  }
    }

  .request-password-reset-page__bg-image {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 420px 521px;
    width: 420px;
    height: 521px;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }

  @media screen and (width <= 720px) {
    .request-password-reset-page__hidden-content {
      display: none;
      visibility: hidden;
    }
  }

.request-password-reset-page-form {
  width: 100%;
}

.request-password-reset-page-form__type-link {
      margin: 25px auto;
      text-align: center;
  }

.request-password-reset-page-form__type-link > a {
          color: #007aff;
          text-decoration: none;
      }

.request-password-reset-page-form__header {
      width: 100%;
      height: 83px;
      display: flex;
      align-items: center;
      box-shadow: 0 0 20px 0 rgb(0 0 0 / 10%);
      padding: 10px 30px;
  }

.request-password-reset-page-form__header > svg {
          height: 36px;
          color: #24b248;
          margin-right: 20px;
      }

.request-password-reset-page-form__header-text-container {
          text-align: left;
          line-height: 19px;
          font-size: 14px;
          color: #8e8e93;
          width: 180px;
      }

.request-password-reset-page-form__header-text-container > h4 {
              color: #24b248;
              font-size: 18px;
              line-height: 25px;
              font-family: Avenir;
              font-weight: normal;
              margin: 0;
          }

.request-password-reset-page-form__error-text-area {
      margin: 8px 0;
      height: 39px;
  }

.request-password-reset-page-form__error-text-area p {
          font-size: 10px;
          color: red;
          margin: 0;
      }

.request-password-reset-page-form__button {
      height: 32px;
      width: 100%;
      border-radius: 32px;
      box-shadow: 0 10px 20px 0 rgb(0 26 6 / 20%);
  }

.request-password-reset-page-form__button .r-button--primary {
          color: var(--color-grayscale-1);
          background-color: #24b248;
      }

.request-password-reset-page-form__input-container {
    width: 100%;
  }

.request-password-reset-page-form__input-container .request-password-reset-page-form__input {
          appearance: none;
          background: transparent;
          border: 0 white;
          border-bottom: 1px solid #d8d8d8;
          border-radius: 0;
          color: #333;
          display: block;
          margin-top: 14px;
          outline: 0;
          padding: 4px 0;
          width: 100%;
          font-family: Avenir;
          line-height: 17px;
          font-size: 14px;
      }

.request-password-reset-page-form__control {
      overflow: hidden;
      position: relative;
      width: 100%;
  }

.request-password-reset-page-form__control::after {
          border-bottom: 1px solid #24b248;
          border-radius: 0;
          bottom: 0;
          content: '';
          display: block;
          left: 0;
          margin: 0 auto;
          position: absolute;
          right: 0;
          transform: scaleX(0);
          transition: all 0.25s;
          width: 1%;
      }

.request-password-reset-page-form__label {
    color: #ababab;
    display: block;
    font-weight: thin;
    left: 0;
    margin: 0;
    padding: 14px 0 0;
    position: absolute;
    top: 0;
    transition: all 0.25s;
    width: 100%;
  }

.request-password-reset-page-form--is-active .request-password-reset-page-form__input {
      border-bottom: 0;
    }

.request-password-reset-page-form--is-active .request-password-reset-page-form__control::after {
        border-bottom: 1px solid #24b248;
        border-radius: 0;
        transform: scaleX(200);
      }

.request-password-reset-page-form--is-active .request-password-reset-page-form__label {
      color: #24b248;
      font-size: 0.7rem;
      transform: translateY(-14px);
    }
`, "",{"version":3,"sources":["webpack://./app/pages/RequestPasswordResetPage/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAgD3B;;EA9CE;IACE,aAAa;IACb,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EAOzB;;EALE;;EARF;MASI,aAAa;MACb,YAAY;MACZ;EAEJ;IADE;;EAGF;IACE,aAAa;IACb,YAAY;IACZ,aAAa;IACb,uBAAuB;;;EAUzB;;EARE;;EANF;MAOI,YAAY;MACZ,aAAa;MACb,kBAAkB;MAClB;;;EAIJ;IAHE;;EAKF;IACE,yDAA6D;IAC7D,4BAA4B;IAC5B,YAAY;IACZ,aAAa;IACb,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE;MACE,aAAa;MACb,kBAAkB;IACpB;EACF;;AAGF;EACE,WAAW;AA6Ib;;AA3IE;MACI,iBAAiB;MACjB,kBAAkB;EAMtB;;AAJI;UACI,cAAc;UACd,qBAAqB;MACzB;;AAGJ;MACI,WAAW;MACX,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,uCAAuC;MACvC,kBAAkB;EAwBtB;;AAtBI;UACI,YAAY;UACZ,cAAc;UACd,kBAAkB;MACtB;;AAEA;UACI,gBAAgB;UAChB,iBAAiB;UACjB,eAAe;UACf,cAAc;UACd,YAAY;MAUhB;;AARI;cACI,cAAc;cACd,eAAe;cACf,iBAAiB;cACjB,mBAAmB;cACnB,mBAAmB;cACnB,SAAS;UACb;;AAIR;MACI,aAAa;MACb,YAAY;EAOhB;;AALI;UACI,eAAe;UACf,UAAU;UACV,SAAS;MACb;;AAGJ;MACI,YAAY;MACZ,WAAW;MACX,mBAAmB;MACnB,2CAA2C;EAM/C;;AAJI;UACI,+BAA+B;UAC/B,yBAAyB;MAC7B;;AAGJ;IACE,WAAW;EAkBb;;AAhBI;UACI,gBAAgB;UAChB,uBAAuB;UACvB,eAAe;UACf,gCAAgC;UAChC,gBAAgB;UAChB,WAAW;UACX,cAAc;UACd,gBAAgB;UAChB,UAAU;UACV,cAAc;UACd,WAAW;UACX,mBAAmB;UACnB,iBAAiB;UACjB,eAAe;MACnB;;AAGJ;MACI,gBAAgB;MAChB,kBAAkB;MAClB,WAAW;EAgBf;;AAdI;UACI,gCAAgC;UAChC,gBAAgB;UAChB,SAAS;UACT,WAAW;UACX,cAAc;UACd,OAAO;UACP,cAAc;UACd,kBAAkB;UAClB,QAAQ;UACR,oBAAoB;UACpB,qBAAqB;UACrB,SAAS;MACb;;AAGJ;IACE,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,OAAO;IACP,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,MAAM;IACN,qBAAqB;IACrB,WAAW;EACb;;AAGE;MACE,gBAAgB;IAClB;;AAGE;QACE,gCAAgC;QAChC,gBAAgB;QAChB,sBAAsB;MACxB;;AAGF;MACE,cAAc;MACd,iBAAiB;MACjB,4BAA4B;IAC9B","sourcesContent":[".request-password-reset-page {\n  display: flex;\n  height: 100vh;\n  justify-content: center;\n  align-items: center;\n  background-color: #e8f4f9;\n\n  &__left-sidebar {\n    padding: 30px;\n    width: 100vw;\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n  \n    @media screen and (width >= 720px) {\n      padding: 30px;\n      width: 300px;\n      height: 521px;\n    }\n  }\n\n  &__content {\n    display: flex;\n    width: 100vw;\n    height: 100vh;\n    background-color: white;\n\n    @media screen and (width >=720px) {\n      width: 720px;\n      height: 521px;\n      border-radius: 6px;\n      box-shadow: 0 20px 40px 0 rgb(0 26 6 / 20%);\n    }\n  \n\n  }\n\n  &__bg-image {\n    background-image: url('../../images/aerial_shot_cropped.jpg');\n    background-size: 420px 521px;\n    width: 420px;\n    height: 521px;\n    border-top-right-radius: 6px;\n    border-bottom-right-radius: 6px;\n  }\n\n  @media screen and (width <= 720px) {\n    &__hidden-content {\n      display: none;\n      visibility: hidden;\n    }\n  }\n}\n\n.request-password-reset-page-form {\n  width: 100%;\n\n  &__type-link {\n      margin: 25px auto;\n      text-align: center;\n\n      & > a {\n          color: #007aff;\n          text-decoration: none;\n      }\n  }\n\n  &__header {\n      width: 100%;\n      height: 83px;\n      display: flex;\n      align-items: center;\n      box-shadow: 0 0 20px 0 rgb(0 0 0 / 10%);\n      padding: 10px 30px;\n\n      & > svg {\n          height: 36px;\n          color: #24b248;\n          margin-right: 20px;\n      }\n\n      &-text-container {\n          text-align: left;\n          line-height: 19px;\n          font-size: 14px;\n          color: #8e8e93;\n          width: 180px;\n\n          & > h4 {\n              color: #24b248;\n              font-size: 18px;\n              line-height: 25px;\n              font-family: Avenir;\n              font-weight: normal;\n              margin: 0;\n          }\n      }\n  }\n\n  &__error-text-area {\n      margin: 8px 0;\n      height: 39px;\n    \n      p {\n          font-size: 10px;\n          color: red;\n          margin: 0;\n      }\n  }\n\n  &__button {\n      height: 32px;\n      width: 100%;\n      border-radius: 32px;\n      box-shadow: 0 10px 20px 0 rgb(0 26 6 / 20%);\n    \n      & .r-button--primary {\n          color: var(--color-grayscale-1);\n          background-color: #24b248;\n      }\n  }\n\n  &__input-container {\n    width: 100%;\n\n      .request-password-reset-page-form__input {\n          appearance: none;\n          background: transparent;\n          border: 0 white;\n          border-bottom: 1px solid #d8d8d8;\n          border-radius: 0;\n          color: #333;\n          display: block;\n          margin-top: 14px;\n          outline: 0;\n          padding: 4px 0;\n          width: 100%;\n          font-family: Avenir;\n          line-height: 17px;\n          font-size: 14px;\n      }\n  }\n\n  &__control {\n      overflow: hidden;\n      position: relative;\n      width: 100%;\n    \n      &::after {\n          border-bottom: 1px solid #24b248;\n          border-radius: 0;\n          bottom: 0;\n          content: '';\n          display: block;\n          left: 0;\n          margin: 0 auto;\n          position: absolute;\n          right: 0;\n          transform: scaleX(0);\n          transition: all 0.25s;\n          width: 1%;\n      }\n  }\n\n  &__label {\n    color: #ababab;\n    display: block;\n    font-weight: thin;\n    left: 0;\n    margin: 0;\n    padding: 14px 0 0;\n    position: absolute;\n    top: 0;\n    transition: all 0.25s;\n    width: 100%;\n  }\n\n  &--is-active {\n    .request-password-reset-page-form__input {\n      border-bottom: 0;\n    }\n\n    .request-password-reset-page-form__control {\n      &::after {\n        border-bottom: 1px solid #24b248;\n        border-radius: 0;\n        transform: scaleX(200);\n      }\n    }\n\n    .request-password-reset-page-form__label {\n      color: #24b248;\n      font-size: 0.7rem;\n      transform: translateY(-14px);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
